import React, { useState } from "react";
import css from "./LoginPage.module.scss";
import { NavLink, useNavigate } from "react-router-dom";
import { useSelector } from 'react-redux'
import SplashScreen from "../../SplashScreen/SplashScreen";
import { useForm } from "react-hook-form";
import { checkUser, DoLogin } from "../../../Services/AuthServices";
import axios from '../../../Axios/Default'
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";
// import axios from "axios";
const LoginPage = () => {
  
  const [IsAlert, setIsAlert] = useState(false);

  const location = useLocation();
  const pathSegments = location.pathname.split('/');
  const successSegment = pathSegments.includes('success');
  const expiredSegment = pathSegments.includes('expired');
  const alreadySegment = pathSegments.includes('already');
  const { token } = useParams();

  // alert(successSegment)



  const navigate = useNavigate();
  const Step = useSelector(state => state.Step)
  const {register, handleSubmit, formState: { errors }, setError} = useForm({defaultValues: {username: "",password: ""}});
  const [showPassword, setShowPassword] = useState(false);

  const [state, setNewState] = useState({ 
    isStarted: false,
    isVisible: false, 
    isBackdrop: false, 
    title: '', 
    content: <div></div>, 
    background: '',
    loginError: false
  });
  
  const setState = data => {
    setNewState(prevState => ({ ...prevState, ...data }));
  }

  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };
  
  const onStarted = () => {
    setState({ isStarted: true });
  }

  const { isStarted, isVisible, isBackdrop, title, content, background, loginError } = state;

  if (!isStarted && window.isStarted !== true) {
    if(successSegment || expiredSegment || alreadySegment){
      localStorage.clear();
      setIsAlert(true);
    }
    checkUser(token).then((result) => {
      if (result.data.message == true) {
        setIsAlert(true);
      }
    }).catch(({ response }) => {
      if(response.status === 401){
        setIsAlert(false);
      }
    });
    window.isStarted = true;
    return (<SplashScreen onStarted={onStarted} />);
  }
  
  function onSubmit(data) {
    if (!data.username) {
      setError("username", {
        type: "manual",
        message: "Email or Username is required",
      });
    }

    DoLogin(data).then((result) => {
      // console.log(result.data)
      // return false
      localStorage.setItem("access_token", result.data.access_token);
      localStorage.setItem("refresh_token", result.data.refresh_token);
      localStorage.setItem("xsrf_token", result.data.xsrf_token);
      localStorage.setItem("username", result.data.username);
      localStorage.setItem("email", result.data.email);
      localStorage.setItem("name", result.data.name);
      localStorage.setItem("user_id", result.data.user_id);
      localStorage.setItem("stasion_id", result.data.station_id);
      localStorage.setItem("station", JSON.stringify(result.data.station_code));
      localStorage.setItem("user_coach_mark", 1);
      localStorage.setItem("password", data.password);
      localStorage.setItem("coachmark", result.data.user_coach_mark);
      localStorage.setItem("station_get", btoa(result.data.station_code[0].station_code));
      localStorage.setItem("start_date", result.data.station_code[0].start_date_safe_running);
      localStorage.setItem("revenue_today", 0);
      localStorage.setItem("total_consumption", 0);

      
      axios.defaults.headers.common["Authorization"] = `Bearer ${result.data.access_token}`;

      if(result.data.user_coach_mark == false){
        window.location.href = "/monitoring/plant-management";
        return true
      }
      if(result.data.station_code.length > 1){
        window.location.href = "/monitoring/plant-management";
      }else{
        window.location.href = "/monitoring/home";
      }

    }).catch(({ response }) => {
      // alert('asd')
      if(response.status === 401){
        setState({ loginError: true });
      }
    });
  }

  const hideModal = () => {
    setIsAlert(false)
};


  return (
    <div className="" style={{height:'100vh'}}>
      {(successSegment && IsAlert) && (
            <div className={css.popup_wrap} onClick={hideModal}>
            <div className={css.content_popup}>          
                <i class="fi fi-rr-cross-small" onClick={hideModal}></i>
                <img src="/monitoring/assets/success.png" />
                <b>Register Successfull</b>
                <p>Please login for access your account</p>
            </div> 
        </div>
      )}
      
      {(expiredSegment && IsAlert) && (
            <div className={css.popup_wrap} onClick={hideModal}>
            <div className={css.content_popup}>          
                <i class="fi fi-rr-cross-small" onClick={hideModal}></i>
                <img src="/monitoring/assets/warning.png" />
                <b>Token is expired</b>
                <p>Please register again and verify your account</p>
            </div> 
        </div>
      )}
      
      {(alreadySegment && IsAlert) && (
            <div className={css.popup_wrap} onClick={hideModal}>
            <div className={css.content_popup}>          
                <i class="fi fi-rr-cross-small" onClick={hideModal}></i>
                <img src="/monitoring/assets/warning.png" />
                <b>Your account is alredy registered</b>
                <p>Please login with your account</p>
            </div> 
        </div>
      )}
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="container">
          <div className="row">
            <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 p-3">
              <div className={css.header_white}>
                {/* <div className={css.back_button}>
                  <i class="fi-rr-arrow-small-left" />
                </div>
                <label>Back</label> */}
              </div>
            </div>
          </div>
          <div className={css.wrap_form_login}>
            <div className="row pt-4">
              <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 p-3 text-center">
                <div className={css.title}>Login</div>
              </div>
            </div>
            <div className="row pt-3">
              <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                <label>Username/Email</label>
                <input 
                type="text" 
                className={css.input}  
                placeholder="Enter Username/Email" 
                  {...register("username", {
                    required: {
                      value: true,
                      message: "Email or Username is required",
                    },
                  })}
                />
              </div>
            </div>

            <div className="row pt-3">
              <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                <label>Password</label>
                <input
                  type={showPassword ? "text" : "password"}
                  className={css.input_password}
                  placeholder="Enter Password"
                  {...register("password", {
                    required: {
                      value: true,
                      message: "Email or Username is required",
                    },
                  })}
                />
                {showPassword ? (
                  <img
                    src="/monitoring/assets/Eye.svg"
                    className={css.eye_password}
                    onClick={toggleShowPassword}
                  />
                ) : (
                  <img
                    src="/monitoring/assets/EyeClose.svg"
                    className={css.eye_password}
                    onClick={toggleShowPassword}
                  />
                )}
              </div>
            </div>
            { loginError == true && 
              <span className="text-danger error_message">
                Login failed! Enter the correct username and password provided by MODENA Energy.
              </span>
            }
            {(errors.username && errors.password) && loginError == true && (
              <span className="text-danger error_message">
                Login failed! Enter the correct username and password provided by MODENA Energy.
              </span>
            )}
            

            <div className="row pt-3">
              <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                <NavLink to="/reset-password">
                  <div className={css.forgot_password}>Forgot Password?</div>
                </NavLink>
              </div>
            </div>
          </div>
        </div>
        <div className={css.button_bottom_wrap}>
          <div className="container">
            <div className="row">
              <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                  <button>Login</button>
              </div>
            </div>

            <div className="row">
              <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                <p>By logging in, I accept MODENA Energy's </p>
                <label>
                  <NavLink to='/profile/settings/privacypolicy'>Terms of Use & Privacy Policy.</NavLink>
                </label>
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default LoginPage;
